import { atom } from "jotai";
import {
  isTourOrExplanationRunningAtom,
  tourIntroStepAtom,
} from "./tourStateAtoms";
import { nodesAtom } from "../nodes";

/**
 * Derived atom that tracks if tours or explanations are currently active.
 * The system is considered active if:
 * 1. Any tour or explanation operation is currently running
 * 2. The tour intro step is being shown
 * 3. There are visible annotation nodes on the canvas (tours or explanations)
 */
export const isTourOrExplanationActiveAtom = atom((get) => {
  // Check cheap conditions first - early returns avoid expensive node scanning
  const isTourOrExplanationRunning = get(isTourOrExplanationRunningAtom);
  if (isTourOrExplanationRunning) {
    return true; // Early return - no need to scan nodes
  }

  const tourIntroStep = get(tourIntroStepAtom);
  if (tourIntroStep) {
    return true; // Early return - no need to scan nodes
  }

  // Only scan expensive nodes if cheaper checks failed
  const nodes = get(nodesAtom);
  return nodes.some((node) => node.type === "annotation" && !node.hidden);
});

isTourOrExplanationActiveAtom.debugLabel = "isTourOrExplanationActiveAtom";
